import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

const deleteDeviceConfigQueueThunk = createAsyncThunk(
  'organizations/deleteDeviceConfigQueueThunk',
  async (deviceId: number) => {
    try {
      const apiPointName = 'deleteDeviceConfigQueue';

      return await doFetch<typeof apiPointName>({
        apiPointName,
        urlParams: { id: deviceId },
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default deleteDeviceConfigQueueThunk;
